import React from "react";
import { useHistory } from "react-router-dom";
import { Cancel as CancelIcon } from "@material-ui/icons";
import { Paper } from "@material-ui/core";

import Button from "../../components/Button";
import { useStyles } from "./styles";

export const PaymentFailed = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleRetry = () => {
    history.push("/pilot/purchase");
  };

  const handleBackToProfile = () => {
    history.push("/pilot/profile");
  };

  return (
    <div className={classes.container}>
      <Paper className={classes.content}>
        <CancelIcon className={classes.icon} />
        <div className={classes.title}>Payment Failed!</div>
        <div className={classes.message}>
          Unfortunately, your transaction could not be completed. Please try again or
          contact us if the issue persists.
        </div>
        <div className={classes.buttonContainer}>
          <Button
            text="Back to Profile"
            onClick={handleBackToProfile}
            classes={`${classes.button} ${classes.backButton}`}
          />
          <Button
            text="Try Again"
            onClick={handleRetry}
            classes={`${classes.button} ${classes.retryButton}`}
          />
        </div>
      </Paper>
    </div>
  );
};

export default PaymentFailed;
